import { jsx as _jsx } from "react/jsx-runtime";
import { withBaseIcon } from '../src/Icons.utils';
export const Link1Line = (props) => withBaseIcon(_jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", role: "img", children: _jsx("path", { d: "M14.5 5H15V5C18.866 5 22 8.13401 22 12V12C22 15.866 18.866 19 15 19V19H14.5M9.5 5H9V5C5.13401 5 2 8.13401 2 12V12C2 15.866 5.13401 19 9 19V19H9.5M8 12H16", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) }), props);
Link1Line.iconName = 'link-1';
Link1Line.displayName = 'Link1Line';
export default Link1Line;
